function toCssClasses(classe, numbers = 12, preencher = false) {
    const cols = numbers ? numbers.toString().split(' ') : []
    let classes = ''

    if (!preencher) {
        if (cols.length === 1) {
            classes += `col-${cols[0]}`
        } else {
            if (cols[0]) classes += `col-xs-${cols[0]}`
            if (cols[1]) classes += ` col-sm-${cols[1]}`
            if (cols[2]) classes += ` col-md-${cols[2]}`
            if (cols[3]) classes += ` col-lg-${cols[3]}`
        }
    } else {
        classes += 'col'
    }

    if (classe) {
        classes += ' ' + classe
    }

    return classes
}

export function Grid(props){
    const gridClasses = toCssClasses(props.classe, props.cols || '12', props.preencher)

    return (
        <div className={gridClasses}>
            {props.children}
        </div>
    )
}